import { resourceReducer } from 'utils/reducerGenerator';

const stats = resourceReducer({ namespace: 'STAT' });

export const { EDIT_IN, FETCH, FETCH_FAIL, FETCH_SUCCESS } = stats.types;

export default stats.reducer;



// WEBPACK FOOTER //
// ./src/redux/stats/reducer.js